module.exports = __webpack_public_path__ + "img/little-symmetry-neutral.0de1dd54.svg";